<template>
  <div class="">
   

  

      <div class="content">
        <div class="conLeft">
          <!-- {{ data }} -->
          <div class="menu">
            <div v-for="(entries, date) in data" :key="date" class="entry">
              <h2 @click="openChild(entries,date)"   :class="{ 'rotate': active == date }"><i class="icon"></i>{{ date }}</h2>
              <div v-for="(details, category) in entries" v-if="active == date"  :class="{ 'active': activeChild == category }" :key="category" class="category">
                <h3 @click="clickChild(details, category)">{{ category }}</h3>
              </div>
            </div>
          </div>

        </div>
        <div class="conRight">
          <div v-if="active == '更新公告'">
              <!-- {{ details }} -->
              <ul>
                <li v-for="(detail,key, index) in details" :key="index">
                  <h3>
                    {{ key }}
                  </h3>
                  <p v-for="(v,k, i) in detail" :key="i">
                    {{ k }} {{ v }}
                  </p>
                </li>
              </ul>
          </div>

          
          <div v-if="active == '常见问题'">
              <!-- {{ details }} -->
              <ul>
                <li v-for="(detail,key, index) in details" :key="index">
                  <h3>
                    {{ key }}
                  </h3>
                  <p>{{ detail }}</p>
                </li>
              </ul>
          </div>

        </div>
      </div>
  </div>
</template>

<script>
import data from './content/renew.json'; // 根据实际路径导入 JSON 文件

export default {
  data () {
    return {
      active: '',
      activeChild: '',
      data: data,
      details: '',
      lastActive: ''
    }
  },
  methods: {
    openChild(entries,date) {
      this.details = ''

      if (this.active && date == this.lastActive) {
        this.active =''
        this.activeChild = ''
        return
      }
      this.active = date
      this.lastActive = date


      let firstKey = Object.keys(entries)[0];
      // 获取对象的第一个键对应的值
      let firstValue = entries[firstKey];
      this.details = firstValue
      this.activeChild = firstKey
      console.error(entries,date)
    },
    clickChild(details, category) {
      this.details = details
      this.activeChild = category
      console.error(details,category)
    },
  },
  created() {
    console.error(this.$route.query.details,this.$route.query.title)
    this.active = this.$route.query.title
    this.details = JSON.parse(this.$route.query.details)
    this.activeChild = this.$route.query.activeChild
  }
}
</script>
<style scoped>
  .header-cen {
      margin: 0 auto;
      width: 1460px;
      height: 72px;
      background: #642727;
  }
.head-left {
    float: left;
    color:#fff;
    height: 72px;
    line-height: 70px;
}


.content {
  display: flex;
}
.conLeft {
  width: 280px;
  background: #F5F6F7;
  height: calc(100vh - 72px);
}
.conRight {
  width: calc(100vw - 280px);
}
.menu {
  box-sizing: border-box;
  padding: 24px 0 0 24px
}
.menu h2 {
  font-size: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.menu h3 {
  font-size: 18px;
  cursor: pointer;
} 
.menu h3:hover ,.menu h2:hover {
  color: #107fff
}
.category {
  padding-left: 20px;
  margin: 7px 0;
}
.icon {
  display: inline-block;
  border-left: 6px solid #304265;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  margin-right: 10px;
  vertical-align: middle;
  transition: all .5s;
}
.rotate .icon{
  transform: rotate(90deg)
}

.conRight {
  padding: 30px;
  box-sizing: border-box;
}
.conRight ul li {
  margin-bottom: 20px;
}
.conRight ul li h3{
  font-size: 24px;
}
.conRight ul li p{
  font-size: 16px;
  text-indent: 3em;
  line-height: 30px;
}

.active {
  color: #107fff
}
</style>


// WEBPACK FOOTER //
// src/components/contents.vue